import { EXPORT_FAILURE_CODES, EXPORT_TILE_DIAGNOSTIC_PROPS } from './export-failure.js';
import type { PropRule } from './analytics-types.js';
import { PREMIUM_SOURCE_VALUES, EXPORT_OFFER_VERSION_VALUES, EXPORT_OFFER_EXPERIMENT_VALUES, USER_PLAN_VALUES } from './checkout-metadata.js';
export const EXPORT_SETTINGS_PROPS = {
  output_scale: new Set(['1', '2']),
  output_width: /^[1-9][0-9]{0,4}$/,
  output_height: /^[1-9][0-9]{0,4}$/,
  orientation: new Set(['landscape', 'portrait']),
  paper_size: new Set(['a4', 'letter']),
  layout: new Set(['map-only', 'map-details']),
  extent: new Set(['current-view', 'drawings']),
  include_measurements: new Set(['true', 'false']),
  measurement_units: new Set(['km', 'mi']),
  include_map_link: new Set(['true', 'false']),
  preset: new Set(['map', 'presentation']),
};
export const EXPORT_FLOW_ID_ALLOWLIST = /^[a-f0-9]{64}$/;
export const EXPORT_FORMAT_VALUES = new Set(['png', 'pdf']);
export const EXPORT_ORIENTATION_VALUES = new Set(['landscape', 'portrait']);
export const EXPORT_INTENT_SOURCE_VALUES = new Set([...PREMIUM_SOURCE_VALUES, 'browser_print', 'toolbar_presentation']);
export const EXPORT_PREVIEW_DISMISS_REASON_VALUES = new Set(['close_button', 'backdrop', 'escape']);
export const EXPORT_DWELL_MS_ALLOWLIST = /^[0-9]{1,7}$/;
export const EXPORT_PREVIEW_PROPS = {
  ...EXPORT_SETTINGS_PROPS,
  format: EXPORT_FORMAT_VALUES,
  source: EXPORT_INTENT_SOURCE_VALUES,
  offer_version: EXPORT_OFFER_VERSION_VALUES,
  user_plan: USER_PLAN_VALUES, variant: EXPORT_OFFER_EXPERIMENT_VALUES, export_flow_id: EXPORT_FLOW_ID_ALLOWLIST,
};

export function exportTaskEventProps<const Common extends Record<string, PropRule>>(common: Common) {
  const props = <const Extra extends Record<string, PropRule>>(extra: Extra) => ({ ...common, ...extra });
  return {
  export_pending_15s: props({ format: EXPORT_FORMAT_VALUES, export_flow_id: EXPORT_FLOW_ID_ALLOWLIST, stage: new Set(['preparing', 'offer', 'downloading']) }),
  export_task_failed: props({ ...EXPORT_TILE_DIAGNOSTIC_PROPS, export_flow_id: EXPORT_FLOW_ID_ALLOWLIST, export_task_id: EXPORT_FLOW_ID_ALLOWLIST, format: EXPORT_FORMAT_VALUES, failure_code: EXPORT_FAILURE_CODES, stage: new Set(['preview', 'checkout', 'capture']) }),
  export_delivery: props({ export_flow_id: EXPORT_FLOW_ID_ALLOWLIST, export_task_id: EXPORT_FLOW_ID_ALLOWLIST, format: EXPORT_FORMAT_VALUES, outcome: new Set(['started', 'failed', 'confirmed']), recovery: new Set(['true', 'false']), elapsed_ms: /^[0-9]{1,10}$/ }),
  export_recovery_requested: props({ export_flow_id: EXPORT_FLOW_ID_ALLOWLIST, format: EXPORT_FORMAT_VALUES }),
  export_options_opened: props({ ...EXPORT_SETTINGS_PROPS, format: EXPORT_FORMAT_VALUES, export_task_id: EXPORT_FLOW_ID_ALLOWLIST }),
  export_options_changed: props({ ...EXPORT_SETTINGS_PROPS, format: EXPORT_FORMAT_VALUES, changed_option: new Set(['paperSize', 'orientation', 'layout', 'extent', 'includeMeasurements', 'measurementUnits', 'includeMapLink', 'preset', 'title', 'subtitle', 'typography', 'outputScale']) }),
  };
}
